import { MDBTable, MDBTableBody } from "mdbreact";
import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

function StaticDataModal({ modal, toggleCriteria }) {
  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggleCriteria}
        style={{ maxWidth: "800px" }}
        centered
      >
        <ModalHeader toggle={toggleCriteria}>
          {" "}
          <h5 style={{ fontWeight: "bold" }}>Static Data Criteria</h5>
        </ModalHeader>
        <ModalBody>
          <table className="table table-bordered">
            <MDBTableBody>
              <tr>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Item
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Criteria
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Score
                </th>
              </tr>

              <tr>
                <td>Cultivated Land</td>
                <td>
                  <tr>{">= 3 Acre"}</tr>
                  <tr>{"5-10 Acre"}</tr>
                  <tr>{"10-15 Acre"}</tr>
                  <tr>{"> 15 Acre"}</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>3</tr>
                  <tr>2</tr>
                  <tr>1</tr>
                </td>
              </tr>

              <tr>
                <td>Land Ownership</td>
                <td>
                  <tr>Owned</tr>
                  <tr>Rent</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>

              <tr>
                <td>Livestock (No. of big Animals)</td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  <tr>3</tr>
                </td>
                <td>
                  <tr>2</tr>
                  <tr>3</tr>
                  <tr>4</tr>
                </td>
              </tr>

              <tr>
                <td>Agricultural Machinery</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>

              <tr>
                <td>Existing Borrower</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>

              <tr>
                <td>Household Assets</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>
            </MDBTableBody>
          </table>
        </ModalBody>
      </Modal>
    </>
  );
}

export default StaticDataModal;
